import cropSamplingReducer from "./cropSamplingReducer";

const samplingCropReducers = {
    cropSampling: cropSamplingReducer
};

export default samplingCropReducers;